import { all } from 'redux-saga/effects';
import usersAndTeamsSaga from '../containers/UsersPane/sagas';
import profileSaga from '../containers/ProfilePane/sagas';
import emailTemplatesSaga from '../containers/MessagesPane/sagas';
import apiTokenSaga from '../containers/ApiTokensPane/sagas';
import defaultCountersSaga from '../containers/DefaultCountersPane/sagas';
import integrationsSaga from '../containers/IntegrationsPane/sagas';

export default function* settingsSaga() {
  yield all([
    usersAndTeamsSaga(),
    profileSaga(),
    emailTemplatesSaga(),
    apiTokenSaga(),
    defaultCountersSaga(),
    integrationsSaga()
  ]);
}
